import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState, useEffect } from "react";
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import {Delete as DeleteIcon} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import Button from "@mui/material/Button";
import "../App.css";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "axios";
import { useAcademicYear } from "./AcademicYearContext";


const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  pb:1,
  pr:1,
  color:'black'
};



export default function ReturnProduct({
  staffId1,
  staffName, selectedIssueProductId, roleName,
           
}) {

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("issue_product_details_id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [inventoryRefund, setInventoryRefund] = useState([]);
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [productId, setProductId] =useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [issueProductDetailsIdset, setissueProductDetailsIdset] = useState([]);
  const [quantitySelected, setQuantitySelected] = useState();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

const [validationErrors, setValidationErrors] = useState({});
const [quantitySum, setQuantitySum] = useState();
const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
const [deleteMsg, setDeleteMsg] = useState("");
const [disabledRows, setDisabledRows] = useState([]);
const [userId, setUserId] = useState();
const [staffId, setStaffId] = useState(staffId1);
const [saleStatus, setSaleStatus] = useState([]);
const [issuedStatusId, setIssuedStatusId] = useState(null);
const [createdStatusId, setCreatedStatusId] = useState(null);
const [refundSaleStatusId, setRefundSaleStatusId] = useState(null);
const [partialRefundSaleId, setPartialRefundSaleId] = useState(null);
  const { academicYearId } = useAcademicYear();

   useEffect(() => {
     console.log("Received Academic Year ID:", academicYearId);
   }, [academicYearId]);
 

useEffect(() => {
  const fetchUserData = async () => {
    const email = localStorage.getItem("user_email");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
        { email },
        { headers: { user_email: email } }
      );
      if (response.status === 200) {
        setUserId(response.data.user.user_id);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  fetchUserData();
}, []);




  const getSaleStatus = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getSalesStatus`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        // Extract specific sale_status_id for descriptions "Paid" and "Issued"
        const createdStatus =
          data.find((item) => item.description === "Created")?.issue_product_status_id ||
          null;
       
        const issuedStatus =
          data.find((item) => item.description === "Issued")?.issue_product_status_id ||
          null;
        const partialRefundStatus =
          data.find((item) => item.description === "Partial Return")?.issue_product_status_id ||
          null;
        const refundStatus =
          data.find((item) => item.description === "Returned")?.issue_product_status_id ||
          null;
  
  
        // Set the complete data and the extracted IDs in state
        setSaleStatus(data);
        setCreatedStatusId(createdStatus);
       
        setIssuedStatusId(issuedStatus);
        setPartialRefundSaleId(partialRefundStatus);
        setRefundSaleStatusId(refundStatus);
      } catch (error) {
        console.error("Error fetching sales status:", error);
      }
    };
  
    useEffect(() => {
      getSaleStatus();
    }, []);

const cancelDelete = () => {
  setIsConfirmationOpen(false);
  setMarkedForDelete([]);
  setDisabledRows([]);
  setSelectedQuantity({});
 
};
const handlePopUp = () => {
    setDeleteMsg("Please select product(s) before proceeding with the return.");
    setIsConfirmationOpen(true);
  
};
const handlePopUpConfirm = () => {
  setDeleteMsg("Are you sure you want to return the selected products?");
  setIsConfirmationOpen(true);

};

  useEffect(() => {
    getInventoryRefund();
  }, [staffId, academicYearId, selectedIssueProductId]);
 
  const getInventoryRefund = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/returnProduct/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            issued_to_staff_id: staffId,
            academic_year_id: academicYearId,
            issue_product_id: selectedIssueProductId
          }),
        }
      );
  
      const data = await response.json();
      console.log("inventory refund api", data.inventoryRefund);
  
      // Extract inventoryRefund array from API response
      const { inventoryRefund } = data;
  
      // Identify issue_product_id values that have at least one "Partial Return"
      const issueProductIdsToExclude = new Set(
        inventoryRefund
          .filter(item => item.issue_product_status === "Returned" || item.issue_product_status === "Partial Return")
          .map(item => item.issue_product_details_id)
      );
  
      // Filter out entire issue_product_id groups if they are in the exclusion list
      const filteredData = inventoryRefund.filter(
        (item) => !issueProductIdsToExclude.has(item.issue_product_details_id)
      );
  
      console.log("filteredData", filteredData);
      setInventoryRefund(filteredData);
  

  
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };
  

  const getInventoryRefund2 = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/returnProduct/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: 'include',
          body: JSON.stringify({   issued_to_staff_id: staffId,
            academic_year_id: academicYearId,
            issue_product_id: selectedIssueProductId}),
        }
      );
  
      const data = await response.json();
      console.log("Inventory refund API response:", data);
      // Extract inventoryRefund array from API response
      const { inventoryRefund } = data;
  
      // Identify issue_product_id values that have at least one "Partial Return"
      const issueProductIdsToExclude = new Set(
        inventoryRefund
          .filter(item => item.issue_product_status === "Returned" || item.issue_product_status === "Partial Return")
          .map(item => item.issue_product_details_id)
      );
  
      // Filter out entire issue_product_id groups if they are in the exclusion list
      const filteredData = inventoryRefund.filter(
        (item) => !issueProductIdsToExclude.has(item.issue_product_details_id)
      );
  
      console.log("filteredData", filteredData);
      setInventoryRefund(filteredData);
  
      // Check if inventoryRefund is an array and has at least one item
      if (Array.isArray(data.inventoryRefund) && data.inventoryRefund.length > 0) {
        setInventoryRefund(filteredData);
        // setRefundAmount(data.inventoryRefund[0].refund || 0); // Get refund from the first object
        setSelectedQuantity(data.inventoryRefund[0].quantity || 0); // Get quantity from the first object
      } else {
        setInventoryRefund([]); // Reset inventory refund if empty 
        setSelectedQuantity(0); // Default to 0 if no quantity available
      }
  
    
      
  
    } catch (error) {
      console.error("Error fetching refund data:", error);
      setInventoryRefund([]); // Ensure state is cleared on error
      setSelectedQuantity(0);
    }
  };
  


  useEffect(() => {
    console.log("Updated selectedQuantity:", selectedQuantity);
  }, [selectedQuantity]); // Runs whenever `selectedQuantity` changes


const handleDelete = (issueProductDetailsId, product_id, quantity, staffId, issue_product_id) => {
  // Get the total quantity using selectedQuantity from the state, falling back to the default quantity if not selected
  const totalQuantity = selectedQuantity[issueProductDetailsId] != null ? selectedQuantity[issueProductDetailsId] : quantity;

    // Validation: Ensure quantity is within a valid range
    if (totalQuantity < 1 || totalQuantity > quantity|| totalQuantity === null ){
      console.error(`Error: Quantity can not exceed ${quantity}.`);
      return; // Exit function early if validation fails
    }

    const isAlreadyMarked = markedForDelete.some((item) => item.issueProductDetailsId === issueProductDetailsId);
    


    if (!isAlreadyMarked) {

     
      // Use functional update for state to handle the latest values properly
      setMarkedForDelete((prev) => {
        // Add new row to the list of rows marked for deletion
        const updatedMarkedForDelete = [
          ...prev,
          {
            issueProductDetailsId,
            productId: product_id,
            quantity,  
            staffId,
            issue_product_id: issue_product_id,
            quantitySelected: selectedQuantity[issueProductDetailsId] || null,
          },
        ];

        // Calculate total quantity sum after adding the new row
        const totalQuantitySum = updatedMarkedForDelete.reduce((sum, item) => {
          const rowQuantity = selectedQuantity[item.issueProductDetailsId] !== undefined && selectedQuantity[item.issueProductDetailsId] !== null
            ? selectedQuantity[item.issueProductDetailsId]  // Use quantitySelected if it's defined
            : item.quantity;  // Otherwise, fallback to the quantity from the row
          return sum + rowQuantity;
        }, 0);

        // Update quantity sum after modifying markedForDelete
        setQuantitySum(totalQuantitySum);
       

        // Return the updated markedForDelete state
        return updatedMarkedForDelete;
      });
       // Add the row to disabledRows
       setDisabledRows((prev) => [...prev, issueProductDetailsId]);
    

      // Log values for debugging
      setProductId(product_id);
     
    } else {
      console.warn("This row has already been marked for deletion:", issueProductDetailsId);
    }
  
};

const handleQuantityChange = (issueProductDetailsId, value, maxQuantity) => {
  // Parse the numeric value
  const numericValue = parseInt(value, 10);

  if (value === "" || isNaN(numericValue)) {
    // Allow clearing the input field
    setValidationErrors((prev) => ({
      ...prev,
      [issueProductDetailsId]: `Quantity is required`,
    }));
    setSelectedQuantity((prev) => ({
      ...prev,
      [issueProductDetailsId]: "",
    }));
  } 
  else if (numericValue > maxQuantity) {
    // Show error message for invalid input
    setValidationErrors((prev) => ({
      ...prev,
      [issueProductDetailsId]: `Quantity cannot exceed ${maxQuantity}`, 
    }));
  }else if(numericValue < 1 ){
    setValidationErrors((prev) => ({
      ...prev,
      [issueProductDetailsId]: ``, 
    }));
  }
   else {
    // Clear any errors and update the valid value
    setValidationErrors((prev) => ({
      ...prev,
      [issueProductDetailsId]: null,
    }));
    setSelectedQuantity((prev) => ({
      ...prev,
      [issueProductDetailsId]: numericValue,
    }));
  }
};

// useEffect to update `quantitySelected` whenever `selectedQuantity` changes
useEffect(() => {
  const issueProductDetailsId = issueProductDetailsIdset;

  if (selectedQuantity[issueProductDetailsId] !== undefined) {
    const updatedQuantity = selectedQuantity[issueProductDetailsId];
    setQuantitySelected(updatedQuantity);
    console.log("Updated Quantity:", updatedQuantity); // Log the extracted quantity
    console.log("Updated quantitySelected:", quantitySelected);
  }
}, [selectedQuantity, issueProductDetailsIdset]);


const deleteInventoryRefund = async (markedForDelete) => {
  const payload = markedForDelete.map((item) => {
    // Create a rowPayload for each item in markedForDelete
    const rowPayload = {
      issueProductDetailsId: item.issueProductDetailsId,
      // Only add quantitySelected if it exists, otherwise set quantity to null
      quantitySelected: item.quantitySelected !== undefined && item.quantitySelected !== null ? item.quantitySelected : 0,

      // If quantitySelected is not set, add quantity; otherwise, set it to null
      quantity: item.quantitySelected ===null? item.quantity:null,
      product_id: item.productId,
      issue_product_status: partialRefundSaleId,
      issue_product_status_id: refundSaleStatusId,
      issue_product_id: selectedIssueProductId,
      return_date: new Date(),
      updated_by: userId,
      updated_timestamp: new Date()
    };
  
    return rowPayload;
  });
  
   
  fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/returnProduct/deleteInventoryRefund", {
    method: "POST",
    headers: { "Content-type": "application/json" },
    credentials: 'include',
    body: JSON.stringify({refunds: payload  
      }),
  })
    .then((response) => response.json())
    .then((response) => {
      handleResponse(response);
      setMarkedForDelete([])
      setDisabledRows([])
     
    })
    .catch((error) => console.error("Error adding inventory refund:", error));
};
const handleResponse = (responseObject) => {
  if (responseObject.status === 200) {
    setSnackbar({
      open: true,
      message: "Product(s) returned successfuly.",
      severity: "success",
    });
  
  } 
};

const handleRefund = () => {
  if(markedForDelete.length > 0){
    
    handlePopUpConfirm();
}else{
  handlePopUp();
}
};

const proceedToRefund = () => {
  // Delete marked inventory refunds
  deleteInventoryRefund(markedForDelete);

  // Use setTimeout to wait before fetching inventory refunds
  setTimeout(() => {
    getInventoryRefund2();
  }, 2000); 

  // Close the confirmation dialog
  setIsConfirmationOpen(false);
};




const handleUndo = (issueProductDetailsIdToUndo) => {
  setMarkedForDelete((prev) => {
    // Filter out the rows being undone
    const updatedMarkedForDelete = prev.filter(
      (item) => item.issueProductDetailsId !== issueProductDetailsIdToUndo
    );

    // Recalculate the total quantity sum based on the updated rows
    const totalQuantitySum = updatedMarkedForDelete.reduce((sum, item) => {
      const rowQuantity =
        selectedQuantity[item.issueProductDetailsId] !== undefined &&
        selectedQuantity[item.issueProductDetailsId] !== null
          ? selectedQuantity[item.issueProductDetailsId]
          : item.quantity;
      return sum + rowQuantity;
    }, 0);

    // Update the quantity sum state
    setQuantitySum(totalQuantitySum);

    return updatedMarkedForDelete; // Update markedForDelete with filtered rows
  });

  // Reset selected quantities for the undone row to its original value
  setSelectedQuantity((prev) => {
    const updatedQuantities = { ...prev };
    const originalRow = inventoryRefund.find(
      (row) => row.sales_details_id === parseInt(issueProductDetailsIdToUndo, 10)
    );
    if (originalRow) {
      updatedQuantities[issueProductDetailsIdToUndo] = originalRow.quantity;
    } else {
      delete updatedQuantities[issueProductDetailsIdToUndo]; // Remove the entry if no original value exists
    }
    return updatedQuantities;
  });


   // Enable the input field by removing the row from disabledRows
   setDisabledRows((prev) =>
    prev.filter((id) => id !== issueProductDetailsIdToUndo)
  );
  // setProductId("");
};

const handleToggleDelete = (issueProductDetailsId, product_id, quantity, staffId, issue_product_id) => {
  const isAlreadyMarked = markedForDelete.some((item) => item.issueProductDetailsId === issueProductDetailsId);

  if (isAlreadyMarked) {
    handleUndo(issueProductDetailsId); // Pass the specific `issueProductDetailsId` to undo
  } else {
    handleDelete(issueProductDetailsId, product_id, quantity, staffId, issue_product_id); // Trigger deletion
  }
};



  //  pagination and sorting
   const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    // Reset to default sorting when students are fetched
    setOrder("desc");
    setOrderBy("issue_product_details_id");
  }, [inventoryRefund]);


    // Sorting function
  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
   
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Sort the rows before displaying them
  const sortedRows = inventoryRefund
    .map((row, index) => ({ ...row, index: index + 1 })) // Add index for Serial No.
    .sort(getComparator(order, orderBy));


  return (
    <div >
     
     <div
        style={{
          margin: "10px 0",
          fontSize: 15,
          fontWeight: "bold",
          color: "#0A64A2",
          paddingTop: "0",
        }}
      >
        Indent ID: { selectedIssueProductId}
      </div>
      <div className="main_title1">
  <div>
    Issued Products List of Staff Member: {staffName} &nbsp;&nbsp; Role: {roleName}{" "}
  
  </div>
 
</div>

      
      <TableContainer component={Paper} className='return_sale_table_container'>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align='center' className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "issue_product_details_id"}
                      direction={orderBy === "issue_product_details_id" ? order : "desc"}
                      onClick={() => handleRequestSort("issue_product_details_id")}
                    >
                SL No.
                </TableSortLabel>
                </StyledTableCell>
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "product_name"}
                      direction={orderBy === "product_name" ? order : "desc"}
                      onClick={() => handleRequestSort("product_name")}
                    >
                      Product
                      {orderBy === "product_name" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell"> <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "issue_date"}
                      direction={orderBy === "issue_date" ? order : "desc"}
                      onClick={() => handleRequestSort("issue_date")}
                    >
                     Issue Date
                      {orderBy === "issue_date" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "attribute_value"}
                      direction={orderBy === "attribute_value" ? order : "desc"}
                      onClick={() => handleRequestSort("attribute_value")}
                    >
                     Attribute
                      {orderBy === "attribute_value" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "attribute_name"}
                      direction={orderBy === "attribute_name" ? order : "desc"}
                      onClick={() => handleRequestSort("attribute_name")}
                    >
                     Attribute Value
                      {orderBy === "attribute_name" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
             
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "quantity"}
                      direction={orderBy === "quantity" ? order : "desc"}
                      onClick={() => handleRequestSort("quantity")}
                    >
                Quantity
                      {orderBy === "price" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
             
              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
                  ? sortedRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : sortedRows
                ).map((row, i) => (
              <StyledTableRow key={row.issue_product_details_id }
         >
              <StyledTableCell align='center' component="th" scope="row" className='table-cell-border'>{row.issue_product_details_id}{markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id)  && (
            <div className='centered-red-line' />)}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.product_name} {markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id) && (
            <div className='centered-red-line' /> )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.issue_date} {markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id)  && (
            <div  className='centered-red-line' />  )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.attribute_value} {markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id)  && (
            <div  className='centered-red-line' /> )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.attribute_name}{markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id)  && (
            
            <div  className='centered-red-line'/>)}</StyledTableCell>
                <StyledTableCell align="center" className="table-cell-border">
                {markedForDelete.some((deletedRow) => deletedRow.issueProductDetailsId === row.issue_product_details_id) && (
            <div className="centered-red-line" />
                   )}

  {row.quantity > 1 ? (
    <div>
      <input
       disabled={disabledRows.includes(row.issue_product_details_id)} // Disable if in disabledRows
        type="number"
        value={
          selectedQuantity[row.issue_product_details_id] !== undefined
            ? selectedQuantity[row.issue_product_details_id]
            : row.quantity
        }
        onChange={(e) => {
          const inputValue = e.target.value;

          // Allow backspace and validate input
          handleQuantityChange(row.issue_product_details_id, inputValue, row.quantity);
        }}
        style={{ width: "40px" }}
      />
      {validationErrors[row.issue_product_details_id] && (
        <div style={{ color: "red" }}>{validationErrors[row.issue_product_details_id]}</div>
      )}
    </div>
  ) : (
    <span>{row.quantity}</span> // Static display for quantity <= 1
  )}
</StyledTableCell>



                  <StyledTableCell align="center"style={{ lineHeight: "10px", padding: "5px" }}>
                    <IconButton
                      color="black"  onClick={() => handleToggleDelete(row.issue_product_details_id,row.product_id,row.quantity,row.issued_to_staff_id,row.issue_product_id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </StyledTableCell>
              </StyledTableRow>

            ))}
              <TableRow>
       
      </TableRow>
          </TableBody>
         
          <TableFooter>
                <TableRow>
                  <TablePagination
                    sx={{
                      backgroundColor: "#0A64A2",
                      color: "white",
                      width: "100%",
                    }}
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={9}
                    count={sortedRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
       
        </Table>
      </TableContainer>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center',marginTop:'10px', gap:'10px'
      }}> <Button  className="save_update_btn"  variant="contained"  onClick={() => handleRefund()}>Return</Button>
    </div>
  
      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
          {/* Confirmation Modal */}
          <Modal open={isConfirmationOpen} onClose={cancelDelete}>
        <Box sx={ModalStyle} >
          <Typography sx={{fontSize:'1.1em', color:'#0A64A2'}} >
            {deleteMsg}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
  {markedForDelete.length > 0 && (
    <>
      <Button variant="contained" onClick={proceedToRefund} className="no-btn">
        Yes
      </Button>
      <Button variant="contained" onClick={cancelDelete} className="no-btn">
        No
      </Button>
    </>
  )}
   {!markedForDelete.length&& (
  <Button variant="contained" onClick={cancelDelete} className="no-btn">
    Ok
  </Button>
   )}
</Box>

        </Box>
      </Modal>

    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#0A64A2',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },

}));


